//ESTA FUNCIÓN ES PARA CAMPOS REDUCIDOS COMO NOMBRE, DIRECCIÓN, TELÉFONO
export function sqlCampo (cadena) {
    if (cadena !== null && cadena !== undefined && cadena !== ""){

        //SI COINCIDE ES UNA POSIBLE AMENAZA
        if (/(\'|\<|\>|\=|\%|\(|\))/.test(cadena) === true){
            return true;
        }
        else{
            return false;
        }

    }
    else return false;
}

//ESTA FUNCIÓN ES PARA CAMPOS REDUCIDOS COMO NOMBRE, DIRECCIÓN, TELÉFONO
export function sqlComentario (cadena) {
    if (cadena !== null && cadena !== undefined && cadena !== ""){

        if ((cadena.includes("<") && cadena.includes(">")) || cadena.includes("%3c") && cadena.includes("%3e")){
            return true;
        }

        if (cadena.includes("=") || cadena.includes("%3d")){
            return true;
        }

        if (/([0-9]+'|'[0-9]+)/.test(cadena) === true){
            return true;
        }

        //SI LLEGA AQUÍ REGRESAMOS TRUE
        return false;

    }
    else return false;
}